import { render, staticRenderFns } from "./RequestsComponent.vue?vue&type=template&id=853269fe&scoped=true"
import script from "./RequestsComponent.vue?vue&type=script&lang=js"
export * from "./RequestsComponent.vue?vue&type=script&lang=js"
import style0 from "./RequestsComponent.vue?vue&type=style&index=0&id=853269fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853269fe",
  null
  
)

export default component.exports